import { FETCH_EVENT_LIST, FETCH_INTERNATIONAL_REPORT, SET_EVENT_PAGE_INDEX, SET_EVENT_TOTAL_COUNT } from '../../constants/actionConstants';

const initialState = {
    internationalReportData: [],
    eventListData: [],
    eventTotalCount: 0,
    eventPageIndex: 0,
};

export default (state = initialState, action) => {

    let newState;
    switch (action.type) {

        case FETCH_INTERNATIONAL_REPORT:
            newState = {
                ...state,
                internationalReportData: action.payload
            };
            return newState;
        case FETCH_EVENT_LIST:
            newState = {
                ...state,
                eventListData: action.payload
            };
            return newState;
        case SET_EVENT_PAGE_INDEX:
            newState = {
                ...state,
                eventPageIndex: action.payload
            };
            return newState;
        case SET_EVENT_TOTAL_COUNT:
            newState = {
                ...state,
                eventTotalCount: action.payload
            };
            return newState;
        
        default:
            return state;
    }
}